import React, { useState, useEffect } from "react";
import axios from "axios";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement } from "chart.js";
import { Col, Container, Row } from "react-bootstrap";
import { getApiClient } from "../../libs/axiosInstance";
import { LucideSparkles } from "lucide-react";

ChartJS.register(Title, Tooltip, Legend, ArcElement);

export default function AISalesCard({ data, recs = "" }) {
  const [topProducts, setTopProducts] = useState(data ?? []);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchTopProducts = async () => {
      try {
        const response = await getApiClient().get("/api/sales/top");
        setTopProducts(response.data);
      } catch (err) {
        console.error(err);
        setError("Failed to fetch top products.");
      } finally {
        setLoading(false);
      }
    };
    if (data === undefined) {
      fetchTopProducts();
    }
  }, []);
  useEffect(() => {
    setLoading(data === null);
    setTopProducts(data);
  }, [data]);

  const chartData = {
    labels: topProducts?.map((item) => item.item),
    datasets: [
      {
        label: "Items Sold",
        data: topProducts?.map((item) => item.totalSold),
        backgroundColor: [
          "rgba(54, 162, 235, 0.7)", // Blue
          "rgba(255, 206, 86, 0.7)", // Yellow
          "rgba(75, 192, 192, 0.7)", // Teal
          "rgba(255, 99, 132, 0.7)", // Pink
          "rgba(153, 102, 255, 0.7)", // Purple
        ],
        borderColor: "#fff",
        borderWidth: 2,
      },
    ],
  };

  return (
    <div
      className="graph-header"
      style={{
        backgroundColor: "#fff",
      }}
    >
      <Container fluid>
        <Row>
          <Col>
            {recs ? (
              <div className="mt-2">
                <LucideSparkles /> {recs}
              </div>
            ) : (
              <></>
            )}
          </Col>
        </Row>
      </Container>
      {/* <ul style={{ marginTop: "15px", fontSize: "0.9em" }}>
        {topProducts?.map((product, idx) => (
          <li key={idx}>
            {product.item}: {product.totalSold} sold
          </li>
        ))}
      </ul> */}
    </div>
  );
}
